export const manifest = {
  screens: {
    scr_2ihfx8: { name: "Beach Club", route: "/", position: {"x":160,"y":220} },
    scr_x4xyg1: { name: "SUP", route: "/sup", position: {"x":160,"y":2200} },
    scr_8vip57: { name: "SUP Race", route: "/sup-race", position: {"x":1560,"y":2200} },
    scr_p9cvap: { name: "SUP Tours", route: "/sup-tours", position: {"x":2960,"y":2200} },
    scr_0wbose: { name: "Surfski", route: "/surfski", position: {"x":160,"y":6160} },
    scr_1to1tp: { name: "Wing Foil", route: "/wingfoil", position: {"x":160,"y":4180} },
    scr_pmodyq: { name: "Wing Foil Campaign", route: "/wingfoil-campaign", position: {"x":1560,"y":4180} },
    scr_ns3pos: { name: "Events", route: "/events", position: {"x":160,"y":8140} },
    scr_cmoc39: { name: "Team Building", route: "/team-building", position: {"x":8560,"y":8140} },
    scr_g2ermc: { name: "Water Tribe Fest", route: "/water-tribe-fest", position: {"x":1560,"y":8140} },
    scr_2hai9d: { name: "Workshop Registration", route: "/workshop-registration", position: {"x":2960,"y":8140} },
    scr_7ftejm: { name: "Reset Retreat", route: "/reset-retreat", position: {"x":4360,"y":8140} },
    scr_4krt1y: { name: "Womens SUP Morning", route: "/womens-sup-morning", position: {"x":5760,"y":8140} },
    scr_zjgn3p: { name: "Safe Space On Water", route: "/safe-space-on-water", position: {"x":7160,"y":8140} },
    scr_it1d3c: { name: "Wind Meter", route: "/wind-meter", position: {"x":160,"y":10120} },
    scr_6kq317: { name: "Mens Morning On Water", route: "/mens-morning-on-water", position: {"x":9960,"y":8140} },
    scr_q9ukk1: { name: "Mens Morning Registration", route: "/mens-morning-on-water", state: {"isRegistrationOpen":true}, position: {"x":11360,"y":8140} },
    scr_9jyd2f: { name: "Flow and Pause", route: "/flow-and-pause", position: {"x":12760,"y":8140} },
  },
  sections: {
    sec_dixge9: { name: "Home", x: 0, y: 0, width: 1520, height: 1180 },
    sec_5zbhk8: { name: "SUP Activities", x: 0, y: 1980, width: 4320, height: 1180 },
    sec_eystag: { name: "Wing Foil", x: 0, y: 3960, width: 2920, height: 1180 },
    sec_o1c8gt: { name: "Other Sports", x: 0, y: 5940, width: 1520, height: 1180 },
    sec_gcizqj: { name: "Events & Workshops", x: 0, y: 7920, width: 14120, height: 1180 },
    sec_x9953o: { name: "Tools", x: 0, y: 9900, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_dixge9", children: [
      { kind: "screen", id: "scr_2ihfx8" },
    ] },
    { kind: "section", id: "sec_5zbhk8", children: [
      { kind: "screen", id: "scr_x4xyg1" },
      { kind: "screen", id: "scr_8vip57" },
      { kind: "screen", id: "scr_p9cvap" },
    ] },
    { kind: "section", id: "sec_eystag", children: [
      { kind: "screen", id: "scr_1to1tp" },
      { kind: "screen", id: "scr_pmodyq" },
    ] },
    { kind: "section", id: "sec_o1c8gt", children: [
      { kind: "screen", id: "scr_0wbose" },
    ] },
    { kind: "section", id: "sec_gcizqj", children: [
      { kind: "screen", id: "scr_ns3pos" },
      { kind: "screen", id: "scr_g2ermc" },
      { kind: "screen", id: "scr_2hai9d" },
      { kind: "screen", id: "scr_7ftejm" },
      { kind: "screen", id: "scr_4krt1y" },
      { kind: "screen", id: "scr_zjgn3p" },
      { kind: "screen", id: "scr_cmoc39" },
      { kind: "screen", id: "scr_6kq317" },
      { kind: "screen", id: "scr_q9ukk1" },
      { kind: "screen", id: "scr_9jyd2f" },
    ] },
    { kind: "section", id: "sec_x9953o", children: [
      { kind: "screen", id: "scr_it1d3c" },
    ] },
  ],
}
